import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const MarketplaceFranchiseProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `MarketplaceFranchise/${props.marketplaceFranchiseId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `MarketplaceFranchise`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `MarketplaceVendor/${props.marketplaceVendorId}/Franchises`, method: 'PUT', payload: props.franchises, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `MarketplaceVendor/${props.marketplaceVendorId}/Franchises`, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `MarketplaceFranchise/${props.marketplaceFranchiseId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useMarketplaceFranchiseStore = () => React.useContext(Context);
